export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('es-ES', options);
};

export const formatDateForInput = (date) => {
  const d = new Date(date);
  return d.toISOString().split("T")[0];
};